<template>
<div id="user-info">
  <div class="row">
    <div class="col-xs-offset-1 col-xs-10 col-sm-offset-2
                col-sm-8 col-md-offset-3 col-md-6">
      <div class="panel panel-default">
        <div class="panel-body">
          <h4><strong>{{ title }}</strong></h4>
          <p v-for="(s, k) in subtitles"
             :key="'subtitle-' + k">
            {{ s }}
          </p>
          <div  class="form-group">
            <alert type="warning">
              <p><strong>Attention !</strong></p>
              <p>
                Si vous ne parvenez pas à créer votre compte,
                vérifiez que vous utilisez bien les mêmes nom et prénom
                que dans l'ancien annuaire national, en particulier
                pour les personnes mariées ayant choisi un double nom.
              </p>
            </alert>
          </div>
          <div class="form-group"
                :class="{ 'has-error': nameError }">
            <label for="name" class="control-label">Nom</label>
            <input required
                    id="name"
                    tabindex="1"
                    autofocus
                    class="form-control"
                    :disabled="waiting"
                    v-model.trim="name"
                    @keyup.enter="send"
                    placeholder="Nom"/>
          </div>
          <div class="form-group"
                :class="{ 'has-error': firstNameError }">
            <label for="firstName" class="control-label">Prénom</label>
            <input required
                    id="firstName"
                    tabindex="1"
                    class="form-control"
                    :disabled="waiting"
                    v-model.trim="firstName"
                    @keyup.enter="send"
                    placeholder="Prénom"/>
          </div>
          <div class="form-group"
                :class="{ 'has-error': emailError }">
            <label for="email" class="control-label">Adresse e-mail</label>
            <input required
                    id="email"
                    tabindex="1"
                    class="form-control"
                    v-model.trim="email"
                    :disabled="waiting"
                    type="email"
                    @blur="checkEmail()"
                    @keyup.enter="send"
                    placeholder="Adresse e-mail"/>
          </div>
          <div class="form-group" v-show="false">
            <label for="website" class="control-label">Website</label>
            <input required
                     tabindex="-1"
                     autocomplete="off"
                     id="source"
                     :disabled="waiting"
                     class="form-control"
                     :value="source"
                     placeholder="empty"/>
            </div>
          <collapse v-model="showError">
            <alert type="danger">
              <strong>{{ errorTitle }}</strong>
              <p>{{ error }}</p>
              <a :disabled="waiting"
                 v-if="showContact"
                 @click="$router.push('contact')">Accéder au formulaire de contact</a>
            </alert>
          </collapse>
          <collapse v-model="showSuccess">
            <alert type="info">
              <strong>{{ successTitle }}</strong>
              <p>{{ success }}</p>
            </alert>
          </collapse>

          <btn id="send-button"
               v-if="!showSuccess"
               type="success"
               tabindex="1"
               :disabled="waiting"
               block
               @click="send">Envoyer</btn>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import tools from '@/sui/tools/main'

export default {
  props: {
    title: String,
    subtitles: Array,
    source: String,
    defaultError: String,
    routePrefix: String
  },
  data () {
    return {
      name: '',
      firstName: '',
      email: '',
      nameError: false,
      firstNameError: false,
      emailError: false,
      errorTitle: '',
      error: '',
      successTitle: '',
      success: '',
      waiting: false,
      showContact: false
    }
  },
  computed: {
    showError: function () {
      return this.error !== '' || this.errorTitle !== ''
    },
    showSuccess: function () {
      return this.success !== '' || this.successTitle !== ''
    }
  },
  methods: {
    send: function () {
      this.errorTitle = ''
      this.error = ''
      this.successTitle = ''
      this.success = ''
      this.showContact = false

      if (!this.checkFormContent()) {
        return
      }

      this.waiting = true
      this.emailError = this.nameError = this.firstNameError = false

      const request = {
        name: this.name,
        firstName: this.firstName,
        email: this.email,
        source: this.source === 'account',
        prefix: (this.routePrefix != null) ? this.routePrefix : ''
      }

      let instance = this
      this.$store.dispatch('password/init', request).then(
        (response) => {
          instance.waiting = false
          if (response.data.err != null) {
            instance.emailError = true
            instance.passwordError = true
            instance.errorTitle = 'Echec de la demande.'
            instance.error = this.defaultError
            instance.showContact = true
          } else {
            instance.$notify({
              type: 'success',
              title: 'Demande acceptée !',
              content: `Un e-mail contenant la marche à suivre vous a été envoyé.`
            })

            instance.successTitle = 'Demande acceptée.'
            instance.success = `Un e-mail contenant la marche à suivre vous a été envoyé. Si
vous ne recevez pas cet email, vérifiez s'il n'est pas arrivé dans vos courriers indésirables.
Si le problème persiste, merci de nous contacter en utilisant le formulaire de contact
présent sur le site.`
          }
        }
      ).catch(function (e) {
        instance.waiting = false
        if (e.status === 500) {
          instance.errorTitle = 'Erreur interne.'
          instance.error = `Si cette erreur persiste, merci de contacter
un administrateur.`
        } else {
          instance.errorTitle = 'Serveur injoignable.'
          instance.error = `Merci de vérifier votre connexion internet.`
        }
      })
    },

    checkFormContent: function () {
      return this.checkName() && this.checkFirstName() && this.checkEmail()
    },

    checkName: function () {
      this.nameError = (this.name === '')
      this.error = (this.nameError) ? 'Aucun nom saisi.' : ''
      this.errorTitle = ''

      return !this.nameError
    },

    checkFirstName: function () {
      this.firstNameError = (this.firstName === '')
      this.error = (this.firstNameError) ? 'Aucun prénom saisi.' : ''
      this.errorTitle = ''

      return !this.firstNameError
    },

    checkEmail: function () {
      this.emailError = (this.email === '' || !tools.isEmailValid(this.email))
      this.error = (this.emailError)
        ? 'L\'adresse e-mail saisie est invalide.' : ''
      this.errorTitle = ''

      return !this.emailError
    }
  }
}
</script>
<style scoped lang="less">
#user-info {
    min-height: 100%;

    .jumbotron {
        margin-bottom: 0rem;
    }

    #send-button {
        margin-bottom: 1rem;
    }

    a {
      cursor: pointer;
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to {
        opacity: 0;
    }
}
</style>
